import React from 'react';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiSwitch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';

/** The switch itself, without a label; wrapped by StyledSwitch and by FormSwitch. */
export const SwitchControl = styled(MuiSwitch)(({ theme, size }) => ({
  width: size === 'small' ? 38 : 42,
  height: size === 'small' ? 20 : 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: size === 'small' ? 1 : 2,
    margin: size === 'small' ? 1 : 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: `translateX(${size === 'small' ? 18 : 16}px)`,
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: size === 'small' ? 16 : 19,
    height: size === 'small' ? 16 : 19,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#5A5A5A',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

/** `disabledTooltip` is shown on hover while the switch is disabled. */
export default function StyledSwitch({
  id = '',
  disabled = false,
  disabledTooltip = null,
  label = '',
  checked = false,
  labelPlacement = 'end',
  size = 'medium',
  sx = {},
  onChange = () => {},
  onClick = () => {},
}) {
  const control = (
    <FormControlLabel
      id={id}
      labelPlacement={labelPlacement}
      disabled={disabled}
      sx={{
        display: 'flex',
        alignItems: 'center',
        m: 0,
        gap: '12px',
        ...sx,
      }}
      control={
        <SwitchControl
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          size={size}
          edge="start"
        />
      }
      label={label}
    />
  );

  if (!disabled || disabledTooltip == null) return control;

  // A disabled switch receives no pointer events, so the tooltip listens on a wrapper.
  return (
    <Tooltip title={disabledTooltip}>
      <span style={{ display: 'inline-flex' }}>{control}</span>
    </Tooltip>
  );
}
